import { render } from "./Testimonials.vue?vue&type=template&id=e400b3f4&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"

import "./Testimonials.vue?vue&type=style&index=0&id=e400b3f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e400b3f4"

export default script